// Published content captured from production on October 23, 2026.
export function ClientCashRates() {
    return (
        <>
            <h2>Cash Sweep Program</h2>
            <p>Cash Sweep Program pays interest at specific rates based on the tiers below, which yields a blended rate over the entire balance.</p>
            <div className="overflow-x-auto"><table>
            <thead>
            <tr>
            <th></th>
            <th colSpan={2}>As of November 03, 2026</th>
            </tr>
            <tr>
            <th>Tier</th>
            <th>Rate</th>
            <th>APY</th>
            </tr>
            </thead>
            <tbody>
            <tr>
            <td>$0–$24,999</td>
            <td>0.39%</td>
            <td>0.39%</td>
            </tr>
            <tr>
            <td>$25,000–$74,999</td>
            <td>0.39%</td>
            <td>0.39%</td>
            </tr>
            <tr>
            <td>$75,000–$99,999</td>
            <td>0.40%</td>
            <td>0.40%</td>
            </tr>
            <tr>
            <td>$100,000–$249,999</td>
            <td>0.40%</td>
            <td>0.40%</td>
            </tr>
            <tr>
            <td>$250,000–$499,999</td>
            <td>0.41%</td>
            <td>0.41%</td>
            </tr>
            <tr>
            <td>$500,000–$1,999,999</td>
            <td>0.42%</td>
            <td>0.42%</td>
            </tr>
            <tr>
            <td>$2,000,000+</td>
            <td>0.97%</td>
            <td>0.97%</td>
            </tr>
            </tbody>
            </table></div>
            <p>You will be paid in accordance with the rates published above, which are effective as of the date stated on the website.</p>
            <p>Rates are variable and may change at any time. Each day, we calculate the interest on your cash and add it to your account monthly. We round the daily interest amount to the nearest $0.01. If your daily interest is less than $0.005, then you may not be paid any interest on that day.</p>
            <div className="overflow-x-auto"><table>
            <thead>
            <tr>
            <th></th>
            <th colSpan={2}>As of November 03, 2026</th>
            </tr>
            <tr>
            <th>Examples</th>
            <th>Blended Rate</th>
            <th>APY</th>
            </tr>
            </thead>
            <tbody>
            <tr>
            <td>$8,000</td>
            <td>0.39%</td>
            <td>0.39%</td>
            </tr>
            <tr>
            <td>$45,000</td>
            <td>0.39%</td>
            <td>0.39%</td>
            </tr>
            <tr>
            <td>$75,000</td>
            <td>0.39%</td>
            <td>0.39%</td>
            </tr>
            <tr>
            <td>$200,000</td>
            <td>0.40%</td>
            <td>0.40%</td>
            </tr>
            <tr>
            <td>$400,000</td>
            <td>0.40%</td>
            <td>0.40%</td>
            </tr>
            <tr>
            <td>$750,000</td>
            <td>0.41%</td>
            <td>0.41%</td>
            </tr>
            <tr>
            <td>$1,500,000</td>
            <td>0.41%</td>
            <td>0.41%</td>
            </tr>
            <tr>
            <td>$3,000,000</td>
            <td>0.60%</td>
            <td>0.60%</td>
            </tr>
            <tr>
            <td>$6,000,000</td>
            <td>0.78%</td>
            <td>0.78%</td>
            </tr>
            </tbody>
            </table></div>
            <p>To help you get a higher interest rate, we combine the Cash Sweep Program funds of all your accounts into one large fund. If you have $10,000 in cash in an individual, retirement, and joint account, we deposit your money as $30,000, rather than three smaller deposits of $10,000. This allows you to reach a higher tier and earn more interest.</p>
            <h2 id="plus">DP CASH PLUS</h2>
            <p>An FDIC-insured enhanced-yield deposit designed to provide income on larger cash deposits, safety of capital and next-day access to funds.</p>
            <div className="overflow-x-auto"><table>
            <thead>
            <tr>
            <th></th>
            <th colSpan={2}>As of November 03, 2026</th>
            </tr>
            <tr>
            <th>Amount Invested</th>
            <td>Rate</td>
            <td>APY</td>
            </tr>
            </thead>
            <tbody>
            <tr>
            <td>$0-$24,999</td>
            <td>0.00%</td>
            <td>0.00%</td>
            </tr>
            <tr>
            <td>$25,000-$49,999</td>
            <td>0.77%</td>
            <td>0.78%</td>
            </tr>
            <tr>
            <td>$50,000-$99,999</td>
            <td>1.35%</td>
            <td>1.36%</td>
            </tr>
            <tr>
            <td>$100,000-$249,999</td>
            <td>1.93%</td>
            <td>1.95%</td>
            </tr>
            <tr>
            <td>$250,000-$499,999</td>
            <td>2.51%</td>
            <td>2.54%</td>
            </tr>
            <tr>
            <td>$500,000-$999,999</td>
            <td>2.90%</td>
            <td>2.94%</td>
            </tr>
            <tr>
            <td>$1,000,000+</td>
            <td>2.90%</td>
            <td>2.94%</td>
            </tr>
            </tbody>
            </table></div>
            <p>Interest rates are based on how much cash you deposit using DP CASH PLUS. Rates are variable and may change at any time.  Each day, we calculate the interest on your cash and add it to your account monthly. We round the daily interest amount to the nearest $0.01. If your daily interest is less than $0.005, then you may not be paid any interest on that day.</p>
            <h3>Important Notes</h3>
            <ul>
            <li>Within a single account, you must have at least $25,000 in DP CASH PLUS to earn interest. If you deposit $15,000  in your individual account and $10,000 in your IRA account, neither account earns interest. As another example, if you deposit $15,000 in your individual account and $30,000 in your IRA, only your IRA earns interest.</li>
            <li>As long as the minimum balance is met and maintained, interest is earned from “dollar one” of the deposit at the applicable rate on the entire  balance in DP CASH PLUS. </li>
            <li>Balances deposited in DP CASH PLUS in one account are not  aggregated with balances deposited in DP CASH PLUS in any other account  for purposes of calculating or earning interest). For example, if $15,000 is deposited in DP CASH PLUS in an IRA account and $15,000 is deposited in DP CASH PLUS in an individual account, even under the same taxpayer ID or membership, neither DP CASH PLUS deposit in either account will earn any interest. As another example, if $15,000 is deposited in DP CASH PLUS in an IRA account and $30,000 is deposited in DP CASH PLUS in an individual account under the same taxpayer ID, only the DP CASH PLUS deposited in the individual account will earn interest, and it will earn interest payable on a balance of $30,000 (not $45,000). </li>
            <li>DP CASH PLUS deposits can be made only in Non-folio Holdings in each  account, and amounts deposited in any one account are not aggregated for  rate purposes with amounts, including amounts deposited as DP CASH PLUS, in  any other account. In addition, unlike our Cash Sweep Program, you must choose to make an DP CASH PLUS deposit (buy it like a security with  the ticker DP.PLUS) — we do not do it automatically for you. </li>
            <li>We do not charge any fees to deposit or withdraw cash from DP CASH PLUS. </li>
            </ul>
            <h2 id="cash">DP CASH</h2>
            <p>The DP CASH deposit earns interest at a flat rate on the applicable balance.</p>
            <div className="overflow-x-auto"><table>
            <thead>
            <tr>
            <th colSpan={2}>As of November 03, 2026</th>
            </tr>
            <tr>
            <td>Rate</td>
            <td>APY</td>
            </tr>
            </thead>
            <tbody>
            <tr>
            <td>0.39%</td>
            <td>0.39%</td>
            </tr>
            </tbody>
            </table></div>
            <h3>Important Notes — DP CASH</h3>
            <ul>
            <li>The above interest rate and annual percentage yield are effective currently and subject to change at any time.</li>
            <li>There is no minimum to earn interest.</li>
            <li>This is a variable rate account so rates are subject to change after the account is open.</li>
            <li>Each day, we calculate the interest on your cash and add it to your account monthly. We round the daily interest amount to the nearest $0.01. If your daily interest is less than $0.005, then you may not be paid any interest on that day.</li>
            <li>Balances in DP CASH are not aggregated with any other insured deposit options for the purposes of determining interest rates.</li>
            </ul>
        </>
    );
}
